import React from 'react';
import { motion } from 'framer-motion';
import { Search, Zap, DollarSign, Handshake, ShieldCheck, ArrowRight } from 'lucide-react';
const CALENDLY_URL = 'https://calendly.com/vantixcredit/diagnostico-de-credito';
const offerings = [{
  number: '01',
  icon: Search,
  title: 'Diagnostico Personalizado',
  description: 'Realizamos un analisis profundo de tu perfil crediticio para entender exactamente donde estas y diseñar una estrategia que funcione especificamente para ti. Ya que cada caso es unico y se trata de forma totalmente personalizada.'
}, {
  number: '02',
  icon: Zap,
  title: 'Estrategia de Optimizacion Experta',
  description: 'Nuestro equipo diseña un plan paso a paso para remover cuentas negativas y errores que pueda tener tu reporte de credito en vias de mejorar, estructurar y fortalecer tu perfil personal. Nuestro objetivo es claro: que los bancos e instituciones financieras te vean como un candidato ideal para aprobarte con las mejores condiciones e intereses mas bajos.'
}, {
  number: '03',
  icon: DollarSign,
  title: 'Acceso a Capital Real',
  description: 'Una vez optimizado tu credito, logramos abrir las puertas al financiamiento. Desde $50,000 hasta $100,000 dolares a traves de uno o mas bancos, lineas de credito, prestamos personales y credit card stacking estrategico para maximizar tu capital para que puedas impulsar tu negocio, hacer inversiones o emprender desde cero.'
}, {
  number: '04',
  icon: Handshake,
  title: 'Acompañamiento en Todo el Proceso',
  description: 'Contaras con atencion personalizada en cada etapa del proceso donde podras consultar y resolver las dudas que tengas acerca de tu caso. Recibiras actualizaciones sobre los resultados que vamos obteniendo y contaras con nuestra guia para llegar a los +700 puntos.'
}];
export function Commitment() {
  return <section className="bg-black py-32 px-4 sm:px-6 lg:px-8 border-t border-white/5 relative overflow-hidden" data-id="element-50" data-mp="3jkhl8we3by3u">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(245,158,11,0.05),transparent_50%)] pointer-events-none" data-id="element-51" data-mp="3l37qxpx1gtf3" />

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-52" data-mp="3c20547bpll1w">
        {/* Heading */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 1,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-center mb-20" data-id="element-53" data-mp="3c447gktymc02">
          <span className="inline-block text-xs font-semibold tracking-[0.3em] uppercase bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent mb-6" data-id="element-54" data-mp="2t9p82u3qkhbp">
            Nuestro Compromiso
          </span>
          <h2 className="text-4xl md:text-6xl font-bold text-white tracking-tight mb-6 leading-[1.1]" data-id="element-55" data-mp="2oc5rvonh9uh4">
            Que{' '}
            <span className="italic font-black bg-gradient-to-b from-amber-200 via-amber-400 to-amber-600 bg-clip-text text-transparent" data-id="element-56" data-mp="24roso6mcaqvz">
              Ofrecemos
            </span>
          </h2>
          <p className="text-lg md:text-xl text-white/50 font-light max-w-2xl mx-auto" data-id="element-57" data-mp="2ep36rzksj3l4">
            Mas que un servicio, una asociacion estrategica para transformar tu
            vida financiera de principio a fin.
          </p>
        </motion.div>

        {/* 2x2 grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-58" data-mp="2iqog5ay48zqk">
          {offerings.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.8,
          delay: index % 2 * 0.1,
          ease: [0.16, 1, 0.3, 1]
        }} className="p-8 md:p-10 rounded-3xl bg-gradient-to-b from-white/[0.04] to-white/[0.01] border border-white/[0.08] hover:border-amber-500/20 transition-all duration-500" data-id="element-59" data-mp="2xfkmn3kiy4p2" data-mpi={index}>
              <div className="flex items-center gap-4 mb-6" data-id="element-60" data-mp="1eh4ty0nranh5">
                <div className="h-12 w-12 rounded-2xl bg-gradient-to-b from-amber-300/20 to-amber-600/10 border border-amber-500/20 flex items-center justify-center shrink-0" data-id="element-61" data-mp="1eipse1d6yqka">
                  <item.icon className="h-6 w-6 text-amber-400" strokeWidth={2} data-id="element-62" data-mp="lshdqjhv6oag" />
                </div>
                <span className="text-sm font-semibold tracking-[0.3em] bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent" data-id="element-63" data-mp="ut5liwgnzsew">
                  {item.number}
                </span>
              </div>

              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-64" data-mp="266hpd7cfcb12">
                {item.title}
              </h3>
              <p className="text-white/50 font-light leading-relaxed" data-id="element-65" data-mp="3qpbowc7x8heo">
                {item.description}
              </p>
            </motion.div>)}
        </div>

        {/* Guarantee banner */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }} className="rounded-3xl border border-amber-500/30 bg-gradient-to-r from-amber-500/[0.08] via-amber-500/[0.03] to-transparent shadow-2xl shadow-amber-500/5 p-8 md:p-12" data-id="element-66" data-mp="3hvp2hcplsqi5">
          <div className="flex flex-col lg:flex-row items-start lg:items-center gap-8" data-id="element-67" data-mp="x7u5240yqeos">
            {/* Icon */}
            <div className="h-16 w-16 rounded-2xl bg-gradient-to-b from-amber-300/20 to-amber-600/10 border border-amber-500/30 flex items-center justify-center shrink-0" data-id="element-68" data-mp="s998qfou0f5m">
              <ShieldCheck className="h-8 w-8 text-amber-400" strokeWidth={2} data-id="element-69" data-mp="1g3azrx9vd76w" />
            </div>

            {/* Text */}
            <div className="flex-1" data-id="element-70" data-mp="12d7hfhe41xmq">
              <div className="text-xs font-semibold tracking-[0.25em] uppercase bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent mb-4" data-id="element-71" data-mp="12a1r5ytqwppf">
                Garantia de Servicio
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-4 leading-tight" data-id="element-72" data-mp="1z2f3cqin68r6">
                Si no removemos nada en 120 dias, te devolvemos el{' '}
                <span className="bg-gradient-to-b from-amber-200 via-amber-400 to-amber-600 bg-clip-text text-transparent" data-id="element-73" data-mp="1l249rfpy6g2b">
                  100%
                </span>{' '}
                de tu inversion
              </h3>
              <p className="text-white/50 font-light leading-relaxed" data-id="element-74" data-mp="9ptsa5gnm6d6">
                Aunque no podemos garantizar resultados, lo que si podemos
                garantizar son dos cosas: la primera es que daremos nuestro
                mayor esfuerzo para brindarte los mejores resultados, y la
                segunda es que si no logramos remover absolutamente nada de tu
                reporte de credito en 120 dias laborables, te reintegramos el
                100% del dinero por las cuentas que no se removieron.{' '}
                <span className="text-white font-semibold" data-id="element-75" data-mp="3jjy3e7rq7tjh">
                  Sin excusas, ni tecnicismos.
                </span>
              </p>
            </div>

            {/* CTA */}
            <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 bg-gradient-to-b from-amber-300 via-amber-400 to-amber-600 hover:brightness-110 text-black font-semibold px-7 py-4 rounded-full transition-all text-base shadow-2xl shadow-amber-500/30 shrink-0 whitespace-nowrap" data-id="element-76" data-mp="3t9zfs2apvnik">
              Empieza Ahora
              <ArrowRight className="h-4 w-4" data-id="element-77" data-mp="2bad1x378kkok" />
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}